/* Mutations */
export const POPULATE_LIST_SUCCESS = "POPULATE_LIST_SUCCESS";
export const SET_POPULATING_LIST_VALUE = "SET_POPULATING_LIST_VALUE";
